import styled from 'styled-components';
import { backgroundAlt } from '../../variables';

const Wrapper = styled.div`
  background: ${backgroundAlt};
  padding: 90px 15px;
  text-align: center;
`;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/SubHeader/Wrapper.js